/**
 * 栈数组
 */
export class Stack {
  items = new WeakMap();

  constructor(options: {
    items?: WeakMap<any, any>;
  } = {}) {
    this.items.set(this, []);
  }

  /**
   * 入栈
   * @ param element
   */
  push(element) {
    this.items.get(this).push(element);
  }

  /**
   * 出栈
   */
  pop() {
    return this.items.get(this).pop();
  }

  /**
   * 栈顶值
   */
  peek() {
    const item = this.items.get(this);
    return item[item.length - 1];
  }

  /**
   * 栈是否为空
   */
  isEmpty(): boolean {
    return this.items.get(this).length === 0;
  }

  /**
   * 栈长度
   */
  size(): number {
    return this.items.get(this).length;
  }

  /**
   * 清空栈
   */
  clear() {
    this.items.set(this, []);
  }
}
